import React, {Component} from 'react';
import {Card, Divider, List} from "antd";
import {Controls} from "./Controls";
import {ProjectSelector} from "./ProjectSelector";

export default class DailyLogDetailsView extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { projectname: this.props.projects ? '-AllProjects' : '' }
  }

  componentDidMount = () => this.props.onMount && this.props.onMount();

  handleChange = id => {
    const projectname = this.props.projects ? id ? ` - Project - ${this.props.projects.find(e => e.id === id).name}` : '- All Projects' : '';
    this.setState({ projectname });
    return this.props.updateFilters(id);
  };

  render() {
    const { projects, name, pdfGenerator } = this.props;
    let { report: { resource: data } = {} } = this.props;
    if (!data) return null;

    data.sort((a, b) => b._meetingdatetime === a._meetingdatetime ? b._datecreated - a._datecreated : b._meetingdatetime - a._meetingdatetime);

    return (
      <Card
        title={<h1>{name}</h1>}
        extra={[<Controls pdfGenerator={() => pdfGenerator(name + this.state.projectname)}/>]}
      >
        <ProjectSelector projects={projects} onSelect={this.handleChange}/>
        <List id='listElement' dataSource={data} renderItem={(mins) => (
          <div className="upcoming-bid-details">
            <p><h1 className="color-primary-0">Meeting Minutes #{mins.number} - {mins.meetingdatetime}</h1></p>
            <p>Prepared on {mins.datecreated} by {mins.createdby}</p>
            <h4>Meeting Type</h4>
            <p className='formatted-text'>{mins.meetingtype}</p>
            <h4>Attendees</h4>
            <p className='formatted-text'>{mins.attendees}</p>
            <h4>Safety</h4>
            <p className='formatted-text'>{mins.safety}</p>
            <h4>Meeting Notes</h4>
            <p className='formatted-text'>{mins.notes}</p>
            <h4>RFIs</h4>
            <p className='formatted-text'>{mins.rfis}</p>
            <h4>New Business</h4>
            <p className='formatted-text'>{mins.newbusiness}</p>
            {mins._nextmeetingdatetime && <React.Fragment>
              <h4>Next Meeting</h4>
              <p className='formatted-text'>{mins.nextmeetingdatetime}</p>
            </React.Fragment>}
            <Divider style={{display: 'none'}}>-</Divider>
            <hr/>
          </div>
        )}/>
      </Card>
    );
  }
}






// WEBPACK FOOTER //
// ./src/components/Reports/MeetingMinutesDetailsView.js